import React, { SVGProps } from "react";

export default function SupSparkle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.38818 12.8882L9.3335 15.4429L11.8882 16.3882L9.3335 17.3336L8.38818 19.8882L7.44287 17.3336L4.88818 16.3882L7.44287 15.4429L8.38818 12.8882Z"
        fill="currentColor"
      />
      <path
        d="M7.78659 6.57797L6.97632 4.38824L6.16605 6.57797L3.97632 7.38825L6.16605 8.19852L6.97632 10.3882L7.78659 8.19852L9.97632 7.38825L7.78659 6.57797Z"
        fill="currentColor"
      />
      <path
        d="M16.7388 9.03779L15.3883 5.38824L14.0379 9.03779L10.3883 10.3882L14.0379 11.7387L15.3883 15.3882L16.7388 11.7387L20.3883 10.3882L16.7388 9.03779Z"
        fill="currentColor"
      />
    </svg>
  );
}
